import axios from 'axios';
// import { TransportMode } from 'store/direction/types';
import { ICapital, LangType } from 'types/common';
import { LOCATION_AUTOSUGGEST_LIMIT } from 'constants/values';

export const getAddress = async (lat: number, lng: number, lang = 'en') => {
  const url = `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${lat}%2C${lng}&lang=${lang}&limit=1&apiKey=${process.env.REACT_APP_HEREMAPS_API_KEY}`;
  const address = await axios.get(url).then((res) => (res.data.items ? res.data.items[0].address : null));
  return address;
};

/** Address suggestions around `capital` — the capital of the admin's selected country (from the profile). */
export const getLocationSuggestions = async (
  q: string,
  capital: ICapital,
  lang: LangType = 'en',
  limit = LOCATION_AUTOSUGGEST_LIMIT
) => {
  const url = `https://autosuggest.search.hereapi.com/v1/autosuggest?at=${capital.lat},${capital.lng}&limit=${limit}&lang=${lang}&q=${q}&apiKey=${process.env.REACT_APP_HEREMAPS_API_KEY}`;
  const results = await axios.get(url).then((res) => res.data.items || null);
  return results;
};
